import {addDelegateEventListener} from '../helpers';
import {BaseClickManager} from './BaseClickManager';
import {ConfigProvider} from "../config/configProvider";

class BaseOfferClickManager extends BaseClickManager
{
    static get conditionsButtonSelector() {
        return '[data-entity="toggle-conditions"]';
    }

    static get conditionsSelector() {
        return '[data-entity="conditions"]';
    }

    /**
     * @param {Element} listContentElement
     */
    static init(listContentElement) {
        super.init(listContentElement);

        addDelegateEventListener(
            listContentElement,
            'click',
            this.conditionsButtonSelector,
            (buttonElement, event) => {
                event.preventDefault();

                let offer = buttonElement.closest(this.entitySelector);
                offer.querySelector(this.conditionsSelector).classList.toggle('is-hidden');
            }
        );
    }

    static createEndpointUrl(buttonElement) {
        let urlPattern = ConfigProvider.get('offer_click_route_pattern');
        let offerId = buttonElement.dataset['value'];
        let shopAlias = buttonElement.dataset['shopAlias'];
        let clickUrl = urlPattern.replace('offer_id', offerId)
            .replace('shop_alias', shopAlias);

        return new URL(clickUrl);
    }
}

export {BaseOfferClickManager}
